import type { MediaType } from "./movies";

export interface CategoryMeta {
  key: MediaType;
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  icon: string;
}

export const categoryList: CategoryMeta[] = [
  {
    key: "电影",
    slug: "movie",
    title: "电影",
    subtitle: "光影之间，看见世界的另一种可能",
    description: "汇集科幻、爱情、悬疑、动作、剧情等多元题材的院线大片与口碑佳作，高清资源在线观看，精彩不容错过。",
    icon: "ri-film-line",
  },
  {
    key: "电视剧",
    slug: "tv",
    title: "电视剧",
    subtitle: "一集一世界，追剧不止步",
    description: "涵盖都市、古装、悬疑、年代、校园等热门剧集类型，连载更新及时跟进，让你不错过每一个精彩瞬间。",
    icon: "ri-tv-2-line",
  },
  {
    key: "综艺",
    slug: "variety",
    title: "综艺",
    subtitle: "欢乐与治愈，一期一会",
    description: "精选真人秀、美食、音乐、喜剧、户外等类型热门综艺，轻松解压，陪你度过每一个闲暇时光。",
    icon: "ri-mic-line",
  },
];

export const typeToSlug: Record<MediaType, string> = {
  电影: "movie",
  电视剧: "tv",
  综艺: "variety",
};

export const slugToType: Record<string, MediaType> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};